import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import SectionUpdates from './components/SectionUpdates';
import SectionTopics from './components/SectionTopics';
import SectionApp from './components/SectionApp';
import SectionFAQ from './components/SectionFAQ';
import SectionIndex from './components/SectionIndex';
import SectionContact from './components/SectionContact';
import SectionFeatures from './components/SectionFeatures';
import SectionRanking from './components/SectionRanking';
import SectionComments from './components/SectionComments';
import SectionCards from './components/SectionCards';
import SectionMedia from './components/SectionMedia';
import SectionCarousel from './components/SectionCarousel';
import SectionAbout from './components/SectionAbout';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const handleHashClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const id = href.substring(1);
      const el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        const headerHeight = 72;
        const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    document.addEventListener('click', handleHashClick);
    return () => document.removeEventListener('click', handleHashClick);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionUpdates />
        <SectionTopics />
        <SectionApp />
        <SectionFAQ />
        <SectionIndex />
        <SectionContact />
        <SectionFeatures />
        <SectionRanking />
        <SectionComments />
        <SectionCards />
        <SectionMedia />
        <SectionCarousel />
        <SectionAbout />
      </main>
      <Footer />
    </>
  );
}